/** Item-scoped Quantis comments for web: the shared queries on the web Supabase client. */

import { getSupabaseClient } from '../../../utils/supabase/client';
import * as core from './boqCommentsCore';

export type {
  BOQComment, ListBOQCommentsInput, AddBOQCommentInput, EligibleBOQCommentMention, ListEligibleBOQCommentMentionsInput, GetBOQCommentInput,
} from './boqCommentsCore';

export const listCommentedBoqItemIds = (documentId: string) => core.listCommentedBoqItemIds(getSupabaseClient(), documentId);
export const listBoqComments = (input: core.ListBOQCommentsInput) => core.listBoqComments(getSupabaseClient(), input);
export const addBoqComment = (input: core.AddBOQCommentInput) => core.addBoqComment(getSupabaseClient(), input);
export const listEligibleBoqCommentMentions = (input: core.ListEligibleBOQCommentMentionsInput) => core.listEligibleBoqCommentMentions(getSupabaseClient(), input);
export const getBoqComment = (input: core.GetBOQCommentInput) => core.getBoqComment(getSupabaseClient(), input);
